import React, { useContext, useEffect, useState } from 'react';
import Layout from '../../layout';
import ModalModule from '../../modal';
import UI from '../../ui';
import Utils from '../../utils';

const { LayoutContext } = Layout;
const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { WrappedInputTextWithLabel } = UI;
const { Communication, Validation } = Utils;

const MeterContactInfoModal = ({ modalId, data: { changeEmailCallback } }) => {
	const [email, setEmail] = useState('');
	const [contactInfo, setContactInfo] = useState('');
	const [validation, setValidation] = useState(0);
	const [errorMessage, setErrorMessage] = useState('');

	const { closeModal, showError } = useContext(ModalContext);
	const { isMobile } = useContext(LayoutContext);

	const fetchEmail = async () => {
		const response = await Communication.getCustomerContactInfo();

		if (!Communication.isSuccessful(response)) {
			return showError({ response });
		}

		const { AccountContactInfo = {} } = response.data;
		const { Email = '' } = AccountContactInfo;

		setContactInfo(AccountContactInfo);
		setEmail(Email);
	};

	useEffect(() => {
		fetchEmail();
	}, []);

	const closeMeterContactInfo = async () => {
		const newContactInfo = {
			...contactInfo,
			Email: email,
		};

		const response = await Communication.updateCustomerContactInfo({
			AccountContactInfo: newContactInfo,
		});

		if (Communication.isSuccessful(response)) {
			closeModal(modalId, ModalButtonActionType.Ok, changeEmailCallback(email));
		} else {
			showError({ response });
		}
	};

	const onFieldBlur = () => {
		if (email === '') {
			setValidation(-1);
			setErrorMessage('This field is required.');
		} else if (!Validation.isValidEmail(email)) {
			setValidation(-1);
			setErrorMessage('Invalid email address.');
		} else {
			setValidation(1);
			setErrorMessage('');
		}
	};

	const onFieldChange = ({ target: { value } }) => {
		setEmail(value);
	};

	return (
		<Modal
			modalId={modalId}
			className="common-settings meter-contact-info-modal"
			header="Meter Contact Info"
			primaryButton={{
				text: 'Save',
				onClick: closeMeterContactInfo,
			}}
		>
			<WrappedInputTextWithLabel
				showErrorBelow={isMobile}
				isInputInvalid={validation === -1}
				errorMessage={errorMessage}
				label="E-Mail:"
				uiElementConfig={{
					type: 'text',
					onBlur: onFieldBlur,
					onChange: onFieldChange,
					value: email,
					maxLength: 64,
					dataqa: 'settings-metercontactinfo',
				}}
			/>
		</Modal>
	);
};

export default MeterContactInfoModal;
